'use strict';

angular.module('bringgApp').directive('default3inchTaskInvoice', function ($translate, $timeout) {
	return {
		restrict: 'E',
		scope: {
			tasks: '=',
			config: '=',
			printedCopies: '=',
			printCallback: '='
		},
		link: function (scope, element) {
			$timeout(scope.printCallback, 100, true, element);
		},
		templateUrl: 'scripts/features/print/invoices/default-3inch-task-invoice.html'
	};
});
